import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownStatusComponent } from './drop-down-status.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
      FormsModule,
      ReactiveFormsModule
  ],
  declarations: [DropDownStatusComponent],
    exports: [
        DropDownStatusComponent
    ]
})
export  class DropDownStatusModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/drop-down-status/drop-down-status.module.ts